'use strict';
import {Infoblock} from './infoblock.js';
import {convertDataVToVue} from '../apply_vue_data_directives';

export class InfoblockAboutme extends Infoblock {
	constructor(component_id) {
		super(component_id);
		this.data  = yalwa.v.components[this.id].data;
		this.vue_data_vars = {
			valueBE : structuredClone(this.data.value || null),
			value : structuredClone(this.data.value || null),
			value_display : structuredClone(this.data.value_display || ''),
			maxLength : structuredClone(this.data.maxLength)
		};
		this.vue_method_vars = {
			saveIconBoxData() {
				this.is_saving = true;
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'profileupdate',
					action: 'update_aboutme',
					data: {
						aboutme : this.value
					},
					include_session: true,
					is_cross_origin: false
				}).then(response => {
					if (response.type === 'success') {
						if (response.vip_completion) {
							document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
						}
						this.valueBE = structuredClone(response.value);
						this.value_display = structuredClone(response.value_display);
						this.checkOverflow();
						this.close();
					}
					yalwa.basics.toast({message: response.label, type: response.type});
				}).finally(() => {
					this.is_saving = false;
				});
				
			},
			close() {
				this.closeDialog();
			},
			closeDialog() {
				this.value = structuredClone(this.valueBE);
				jQuery('html').removeClass('js-no_scroll');
				yalwa.v.component_instances[this.dialog_id].hide();
			}
		};
		this.extras = {
			computed : {
				remaining() {
					return this.maxLength - ((this.value) ? this.value?.length : 0);
				},
				isUnchanged() {
					return this.value === this.valueBE
				}
			}
		}
	}
	setup_vars(Vue) {
		const expanded = Vue.ref(false);
		const isOverflowing = Vue.ref(false);
		const value = Vue.ref(this.data.value);
		const newValue = Vue.ref('');

		const checkOverflow = () => {
			Vue.nextTick(() => {
				const el = document.querySelector(`.js-${this.id} .simplebox__item`);
				if (el) {
					isOverflowing.value = el.scrollHeight > el.clientHeight;
				}
			});
		};

		Vue.onMounted(checkOverflow);
		Vue.watch(() => this.value_display, checkOverflow);

		return {value, newValue, expanded, isOverflowing, checkOverflow}
	}
}